// removed by extract-text-webpack-plugin
module.exports = {"spacing-large":"16px","headerImage":"JoinMergeAccountsModal__headerImage___CVtST","rejectLink":"JoinMergeAccountsModal__rejectLink___2O07U"};


//////////////////
// WEBPACK FOOTER
// ./src/join/components/styles/JoinMergeAccountsModal.css
// module id = 2753
// module chunks = 0 1